export default __webpack_public_path__ + "app/assets/images/common/complete-image-6886557c7c35f92ddd7c94c6256f38c4.png";